// @flow
import { useContext, useEffect } from 'react';
import _isEqual from 'lodash/isEqual';

import usePrevious from '../hooks/usePrevious';

import { SeoContentStateContext } from '../contexts/seoContent';

import type { Node } from 'react';

export default function PageSeoContentApplier({
  children
}: {
  children: null | Node
}) {
  const seoContent = useContext(SeoContentStateContext);
  const prevSeoContent = usePrevious(seoContent);

  useEffect(() => {
    if (!_isEqual(seoContent, prevSeoContent)) {
      if (seoContent.page_title) {
        const titleEl = document.querySelector('head title');

        if (titleEl) {
          const currentTitle = titleEl.innerText;

          if (currentTitle !== seoContent.page_title) {
            titleEl.innerText = seoContent.page_title;
          }
        }
      }

      if (seoContent.meta_desc) {
        const descEl = document.querySelector('head meta[name="description"]');

        if (descEl) {
          const currentContent = descEl.getAttribute('content');

          if (currentContent !== seoContent.meta_desc) {
            descEl.setAttribute('content', seoContent.meta_desc);
          }
        }
      }
    }
  }, [seoContent, prevSeoContent]);

  return children;
}
